<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
export default {
  name: 'Crm'
}

</script>



// WEBPACK FOOTER //
// src/Crm/containers/Crm.vue